import axios from 'axios';
import {
    designationRequest,
    designationsSuccess,
    designationCreateSuccess,
    designationUpdateSuccess,
    designationDeleteSuccess,
    designationFail,
} from '../slices/designationSlice';

// GET active designations — for billing forms (all logged-in users)
export const getdesignations = () => async (dispatch) => {
    try {
        dispatch(designationRequest());
        const { data } = await axios.get('/api/v1/designations');
        dispatch(designationsSuccess(data.designations));
    } catch (err) {
        dispatch(designationFail(err.response?.data?.message || 'Failed to load designations'));
    }
};

// GET all designations including inactive — for admin manage page
export const getAdmindesignations = () => async (dispatch) => {
    try {
        dispatch(designationRequest());
        const { data } = await axios.get('/api/v1/designations');
        dispatch(designationsSuccess(data.designations));
    } catch (err) {
        dispatch(designationFail(err.response?.data?.message || 'Failed to load designations'));
    }
};

// POST — create new designation
export const createdesignation = (designationData) => async (dispatch) => {
    try {
        dispatch(designationRequest());
        const { data } = await axios.post('/api/v1/admin/designations', designationData);
        dispatch(designationCreateSuccess(data.designation));
    } catch (err) {
        dispatch(designationFail(err.response?.data?.message || 'Failed to create designation'));
    }
};

// PUT — update designation
export const updatedesignation = (id, designationData) => async (dispatch) => {
    try {
        dispatch(designationRequest());
        const { data } = await axios.put(`/api/v1/admin/designations/${id}`, designationData);
        dispatch(designationUpdateSuccess(data.designation));
    } catch (err) {
        dispatch(designationFail(err.response?.data?.message || 'Failed to update designation'));
    }
};

// DELETE — delete designation
export const deletedesignation = (id) => async (dispatch) => {
    try {
        dispatch(designationRequest());
        await axios.delete(`/api/v1/admin/designations/${id}`);
        dispatch(designationDeleteSuccess(id));
    } catch (err) {
        dispatch(designationFail(err.response?.data?.message || 'Failed to delete designation'));
    }
};

